import React from 'react';
import MegaphoneIcon from '../../../MegaphoneIcon';
import { WidgetDef, GENERATE_NOTE } from '../types';
import { DemoHead, DemoSearch, DocList, DocItem, useWidgetSite } from '../shared';

// spec 621:6823
const ITEMS: DocItem[] = [
    { title: '171m @ 0.9 g/t Gold Confirms Scale', meta: '27 Aug 2026 · price sensitive', badge: 'Announcement', likes: 62, questions: 5 },
    { title: 'Quarterly Activities & Appendix 5B', meta: '31 Jul 2026', badge: 'Quarterly', likes: 28, questions: 3 },
    { title: 'Investor Presentation — August 2026', meta: '14 Aug 2026', badge: 'Presentation', likes: 17, questions: 2 },
    { title: 'Notice of Annual General Meeting', meta: '19 Jul 2026', badge: 'Notice of meeting', likes: 9, questions: 1 },
    { title: 'Annual Report 2026', meta: '30 Jun 2026', badge: 'Annual', likes: 24, questions: 4 },
];

const asxAnnouncements: WidgetDef = {
    slug: 'asx-announcements',
    name: 'ASX announcements',
    description: 'Every announcement, filtered by category',
    icon: <MegaphoneIcon />,
    title: 'ASX Announcements Widget',
    installed: true,
    page: '/investors/asx-announcements/',
    views: 2180,
    savedCodes: [
        { path: '/', note: 'Carousel · 5 items' },
        { path: '/investors/investors-dashboard/', note: 'List · no filters' },
        { path: '/investors/asx-announcements/', note: 'Full filters + search' },
    ],
    demoPath: '/investors/asx-announcements/',
    addBlocks: [
        { title: '1 · WordPress shortcode', code: '[investi_announcements categories=all questions=on instance="announcements"]' },
        { title: '2 · Or plain HTML', code: '<div data-investi-instance="announcements" data-investi="announcements"\n     data-categories="all" data-questions="on"></div>', dark: true },
    ],
    settings: [
        { kind: 'heading', label: 'Widget style' },
        { kind: 'segmented', key: 'style', options: ['List', 'Tabs', 'Accordion by year', 'Carousel'], default: 'List' },
        { kind: 'heading', label: 'What visitors can do' },
        { kind: 'toggle', key: 'search', label: 'Search box', hint: 'Search by headline', default: true },
        { kind: 'toggle', key: 'filterPrice', label: 'Filter by price sensitive', default: true },
        { kind: 'toggle', key: 'filterCategory', label: 'Filter by category', default: true },
        { kind: 'toggle', key: 'filterYear', label: 'Filter by year', default: true },
        { kind: 'heading', label: 'What it shows' },
        { kind: 'toggle', key: 'likes', label: 'Let visitors like an announcement', hint: 'A like button on every row', default: true },
        { kind: 'toggle', key: 'likeCount', label: 'Show the like count', hint: 'The number beside the button', default: true },
        { kind: 'toggle', key: 'questionCount', label: 'Show the question count', hint: 'How many people have asked about it', default: true },
        { kind: 'toggle', key: 'questions', label: 'Show the questions section', hint: 'The ask box and published answers, under the list', default: true },
        { kind: 'toggle', key: 'priceFlags', label: 'Show price‑sensitive flags', default: true },
        { kind: 'toggle', key: 'category', label: 'Show the category on each row', default: true },
        { kind: 'note', text: 'Likes and questions need a signed‑in investor or an email address, so the numbers are real people, not clicks.' },
    ],
    generateNote: GENERATE_NOTE,
    Demo: ({ settings: s }) => {
        const { short } = useWidgetSite();
        const filters = [s.filterPrice && 'Price sensitive: Any', s.filterYear && 'Year: All'].filter(Boolean) as string[];
        const items = s.priceFlags ? ITEMS : ITEMS.map(i => ({ ...i, meta: i.meta.replace(' · price sensitive', '') }));
        return <>
            <DemoHead title="ASX announcements" sub={`Every announcement ${short} has released`} />
            <DemoSearch placeholder="Search announcements…" showSearch={!!s.search} filters={filters} />
            <DocList items={items} showBadge={!!s.category} likes={!!s.likes} likeCount={!!s.likeCount} questionCount={!!s.questionCount} />
        </>;
    },
};

export default asxAnnouncements;
